module.exports = __webpack_public_path__ + "static/media/background.1a4d19f9.png";